/* unplugin-vue-components disabled */import script from "./noMoreData.vue?vue&type=script&lang=ts&setup=true"
export * from "./noMoreData.vue?vue&type=script&lang=ts&setup=true"

import "./noMoreData.vue?vue&type=style&index=0&id=62fd97b2&scoped=true&lang=scss"

import exportComponent from "/nerv.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62fd97b2"]])

export default __exports__